import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TermsComponent } from '@app/shared/components/terms/terms.component';
import { BaseModal } from '@modals/base-modal';
import { UserTermsDataModel } from '@models/user-terms-data-model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'cstmsr-terms-modal',
    templateUrl: './terms-modal.component.html',
    styleUrl: './terms-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslatePipe, TermsComponent]
})
export class TermsModalComponent extends BaseModal {
	termsData: UserTermsDataModel;
	contactCode: string;
}
